<section class="fill white-text {{ backgroundColorClass }}">
  <div class="grid-col-12 grid-max-width">
    <section
      data-test-sub-header-content
      [ngClass]="{
        'col-1-10 sm-col-1-8 md-col-1-9': hasBasket,
        'col-1-12': !hasBasket
      }"
    >
      <ng-content></ng-content>
    </section>
    <aside
      class="col-11-12 sm-col-9-12 md-col-10-12"
      data-test-basket
      *ngIf="hasBasket"
      [class.border-left]="!showInfoIcon"
    >
      <div class="sub-header-button flex grow flex--end">
        <button
          (click)="openBasket.emit()"
          [attr.title]="'bookingSummary.displayShoppingBasket' | finLocalization"
          [attr.aria-label]="'bookingSummary.displayShoppingBasket' | finLocalization"
          [disabled]="isBasketDisabled || (hasBasketActionInMobileOnly && (isMobile$ | async) === false)"
          class="flex--nogrow btn--no-outline focus-inset"
          [class.disabled]="isBasketDisabled"
        >
          <fcom-icon
            data-test-info-icon
            *ngIf="showInfoIcon && (isMobile$ | async)"
            class="flex--nogrow icon-medium"
            name="info"
          ></fcom-icon>
          <fcom-icon
            *ngIf="!showInfoIcon"
            class="flex--nogrow icon-medium"
            name="{{ isBasketDisabled || !hasActiveBasketState ? 'shopping-cart' : 'shopping-cart-active' }}"
          ></fcom-icon>
          <span class="ps-xsmall-l flex-1 font-body-1 dn-mobile" *ngIf="!showInfoIcon">
            {{ 'cart.title' | finLocalization }}
          </span>
        </button>
        <button
          data-test-edit-search
          *ngIf="(showModifyButton$ | async) === true"
          class="edit-button underline"
          (click)="changeStep.emit(STEPS.ENTRY)"
        >
          {{ 'services.sidebar.modifySearch' | finLocalization }}
        </button>
      </div>
    </aside>
  </div>
</section>
